export const environments = [
  {
    id: '',
    name: 'None',
    path: null,
    format: '.hdr'
  },
  {
    id: 'venice-sunset',
    name: 'Venice Sunset',
    path: '/assets/environment/venice_sunset_1k.hdr',
    format: '.hdr'
  },
  {
    id: 'footprint-court',
    name: 'Footprint Court (HDR Labs)',
    path: '/assets/environment/footprint_court_2k.hdr',
    format: '.hdr'
  }
];
